"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.octal = exports.binary = exports.alphabetNumericSymbol = exports.numberSymbol = exports.alphabetSymbol = exports.number = exports.alphanumeric = exports.alphabet = exports.symbols = exports.hex = void 0;
exports.hex = '0123456789ABCDEFabcdef';
exports.symbols = '[-!$%^&*()_+|~=`{}[]:";<>?,./]' + "'";
exports.alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
exports.alphanumeric = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
exports.number = '0123456789';
exports.alphabetSymbol = 'IJ[A-B!C$Dh%E^FGH&KfgL*f(zMNy)Q_iOfPe+xdRc|zb~S=aTw`{Y}X[]Z\vrW:j";k<ls>t?mVn,o.up/]Uq' + "'";
exports.numberSymbol = '[-!$%9^&*()_8+|~6=7`5{4}[]3:"2;<>?0,.1/]' + "'";
exports.alphabetNumericSymbol = 'IJ[0A-B!1C$3Dh%E^2FGH&4Kf5gL*6f(zMN7y)Q_iOfPe+xdRc|zb~S=aTw`{Y}X[]Z\vrW:j";k<ls8>t?9mVn,o.u7p/]Uq' +
    "'";
exports.binary = '01';
exports.octal = '01234567';
